import React, { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import useLogout from "hooks/useLogout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faUsers,
  faCalendar,
  faBriefcase,
  faShoppingBag,
  faDollarSign,
  faCog,
  faCaretDown,
  faBars,
  faCashRegister,
} from "@fortawesome/free-solid-svg-icons";
import LogoHorus from "Loja/assets/LogoHorus.jpeg";
import { Logout } from "@mui/icons-material";
/* 
  { title: "Dashboard", endpoint: "/sistema", icon: faHome, hasDrop: false },

*/
const menuItems = [

    {
    title: "Caixa",
    icon: faCashRegister,
    hasDrop: false,
    endpoint: "/sistema/caixa",
  },
  {
    title: "Clientes",
    icon: faUsers,
    hasDrop: true,
    dropData: [
      { title: "Listar Clientes", endpoint: "/sistema/clientes" },
      { title: "Novo Cliente", endpoint: "/sistema/create/cliente" },
    ],
  },
  {
    title: "Agendamentos",
    icon: faCalendar,
    hasDrop: true,
    dropData: [
      { title: "Agendamentos", endpoint: "/sistema/agendamentos" },
      { title: "Novo Agendamento", endpoint: "/sistema/create/agendamento" },
    ],
  },
  {
    title: "Profissionais",
    icon: faBriefcase,
    hasDrop: true,
    dropData: [
      { title: "Profissionais", endpoint: "/sistema/profissionais" },
      { title: "Novo Profissional", endpoint: "/sistema/create/profissional" },
    ],
  },
  {
    title: "Produtos e Serviços",
    icon: faShoppingBag,
    hasDrop: true,
    dropData: [
      { title: "Listar Serviços", endpoint: "/sistema/servicos" },
      { title: "Listar Produtos", endpoint: "/sistema/produtos" },
      { title: "Novo Registro", endpoint: "/sistema/create/servprod" },
    ],
  },

  /*
    {
    title: "Financeiro",
    icon: faDollarSign,
    hasDrop: false,
    endpoint: "/sistema/financeiro/resumo",
  },
  {
    title: "Configurações",
    endpoint: "/sistema/configuracoes",
    icon: faCog,
    hasDrop: false,
  },
  */

];

function SidebarItem({ data, isExpanded }) {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);


  return (
    <li className="relative group">
      <button
        onClick={() => (data.hasDrop ? setIsOpen(!isOpen) : navigate(data.endpoint))}
        className="flex items-center w-full p-2 text-left rounded-lg hover:bg-gray-200 "
      >
        <FontAwesomeIcon icon={data.icon} className="text-gray-800 -ml-2 " />
        {isExpanded && <span className="ml-3 text-nowrap">{data.title}</span>}
        {data.hasDrop && isExpanded && (
          <FontAwesomeIcon
            icon={faCaretDown}
            className={`ml-auto transform ${isOpen ? "rotate-180" : ""}`}
            size="sm"
          />
        )}
      </button>

      {/* Dropdown visível ao expandir */}
      {data.hasDrop && isOpen && isExpanded && (
        <ul className="ml-1">
          {data.dropData.map((item, index) => (
            <li key={index} className="w-full cursor-pointer">
              <button
                onClick={() => navigate(item.endpoint)}
                className="flex w-[160px] -ml-11 p-2 text-left text-sm rounded-lg hover:bg-gray-100 "
              >
                <span>{item.title}</span>
              </button>
            </li>
          ))}
        </ul>
      )}

      {/* Mostrar pop-up quando a sidebar está retraída */}
      {!isExpanded && (
        <div className="absolute left-full top-0 ml-2 hidden group-hover:block bg-white shadow-lg rounded-lg w-48 p-2 z-50">
          {data.hasDrop ? (
            <ul>
              {data.dropData.map((item, index) => (
                <li key={index} className="w-full">
                  <button
                    onClick={() => navigate(item.endpoint)}
                    className="flex w-full text-left p-2 text-sm rounded-lg hover:bg-gray-100 "
                  >
                    {item.title}
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <button
              onClick={() => navigate(data.endpoint)}
              className="flex w-full p-2 text-sm rounded-lg hover:bg-gray-100 "
            >
              {data.title}
            </button>
          )}
        </div>
      )}
    </li>
  );
}

function NewPannel() {
  const [isExpanded, setIsExpanded] = useState(true);
  const handleLogout = useLogout();
  return (
    <div className="flex">
      <aside
        className={`h-screen bg-blue-200 px-2 transition-all overflow-y-auto no-scrollbar ${
          isExpanded ? "w-[220px]" : "w-16"
        }`}
        onClick={() => !isExpanded && setIsExpanded(true)}
      >
        <div className="bg-blue-200 p-2 justify-between flex w-full sticky -top-0 z-20 ">
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="mb-4 flex items-center -ml-2 bg-blue-100 shadow-md rounded-full p-2"
            aria-label="Toggle sidebar"
          >
            <FontAwesomeIcon icon={faBars} size="lg" />
          </button>
        </div>

        <ul className="overflow-y-auto  no-scrollbar bg-blue-100 flex-grow h-[80vh] py-4 p-1 shadow-md rounded-[20px]">
          {menuItems.map((item, index) => (
            <SidebarItem key={index} data={item} isExpanded={isExpanded} />
          ))}
        </ul>
        <div className="p-2 justify-between flex w-full sticky -bottom-5 z-20 ">
          <button
            onClick={() => handleLogout()}
            className="flex items-center bg-blue-100 rounded-lg justify-between align-middle -ml-2 p-2 px-4"
            aria-label="Toggle sidebar"
          >
            {isExpanded && (
              <p className="font-semibold hover:text-gray-600 text-gray-800 cursor-pointer m-0 p-0 border rounded-md">encerrar sessão</p>
            )}
            
            <Logout />
          </button>
          
        </div>
      </aside>
      <main className="flex-1 h-screen">
        <div className="bg-blue-200 w-full h-[10%] p-4 flex flex-row shadow-md justify-between">
          <h2 className="text-[12pt] font-semibold">Clinica Horus</h2>
          <div className="bg-slate-400 rounded-full w-[50px] h-[50px] overflow-hidden -mt-5 shadow-sm cursor-pointer">
            <img src={LogoHorus} className="w-[100%] h-[100%] rounded-full" />
          </div>
        </div>
        <div className="flex-1 p-6 h-[90%] overflow-x-hidden overflow-y-scroll no-scrollbar">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default NewPannel;